import ItImg from "../assets/images/it-services.png";
import cloudImg from "../assets/images/cloud.png";
import cyberImg from "../assets/images/cyber-img.png";
import audioImg from "../assets/images/audio.png";
import smartHomesImg from "../assets/images/smart-homes.png";
import networkImg from "../assets/images/network.png";
import dataImg from "../assets/images/data-backup.png";
import softwareImg from "../assets/images/software.png";
import dataBg from "../assets/images/databg.png";
import cloudBg from "../assets/images/cloudbg.png";
import cyberBg from "../assets/images/cyberbg.png";
import itservicesBg from "../assets/images/it-servicesbg.png";

const PatnersData = [];
const missionVisionMenu = [
  {
    name: "About RemotewebNET",
  },
  {
    name: "Vision",
  },
  {
    name: "Mission",
  },
  {
    name: "Objectives",
  },
  {
    name: "Core Values",
  },
];
const services = [
  {
    header: "it services",
    slug: "it-services",
    imgUrl: ItImg,
    bgImg: itservicesBg,
    content1:
      "RemotewebNET provides a wide range of IT solutions for both small and large businesses. From hardware and software installation to cloud-based networking and data storage, our team of experienced IT professionals can help you find the right solution for your business needs. We can provide reliable and secure solutions designed to help you maximize efficiency and save time and money.",
    content2:
      " Our dedicated support staff is always on hand to provide troubleshooting and maintenance services to ensure your IT system remains running smoothly and optimally. Invest in our reliable IT solutions today and stay at the forefront of success with RemotewebNET!",
    menu_items: [
      {
        slug: "",
        title: "on call support",
        desc: "Any technical glitch, even one that lasts only a few minutes, can have an impact on the future of your entire company, particularly if it arises at a crucial time or at an important event. It is essential that suchmistakes do not ruinthe future of your entire firm. With our  on-call  IT  support  services  in  Nigeria,  RemotewebNEThelps  clients  quickly  and professionally to prevent such hardware breakdowns.As a premier IT service provider in Nigeria, it is our goal to offer our clients proactive support that enables them to maintain productivity and corporate success. Because of this, we guarantee that our team of specialists will be available to you for immediate on-call IT help at all times, regardless of how big or minor the issue maybe.",
        path: "",
        isActive: true,
      },
      {
        slug: "",
        title: "24/7 remote it support",
        desc: "We exceed customer expectations with superior remote IT solutions in Nigeriaas the leading provider of IT services in the sector. For IT remote support in Nigeria, contact our team of specialists by phone, chat, email, or throughan automated technology like our  help-desk  portal.  Our  skilled  experts  are  assigned  by  a  capable  staff  at  the  sales offices  to  address  your  inquiry  fully  and  promptly.  When  required,  the  experts  and engineers respond to your problems in as little as 15 minutes.Our  team  submits  reports  on  each  query  for  the  clients  as  well  as  our  own  database using   our   fully   secure,   adaptable,   and   industry-standard   remote   IT   support technologies.We at RemotewebNETcollaborate to provide clients all around Nigeria with remote IT services of unmatched quality and creativity.With our comprehensive IT remote  assistance,  clients  in Nigeriaalways  get  cutting-edge  and  traditional  remote technical  support  solutions.  Find  out  which  remote  IT  solutions  best  meet  the expectationsof your company by contacting us for advice.",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "new office setup",
        desc: "The idea of picturing a beautiful new office is intriguing. However, if you are unfamiliar with the fundamentals needed to execute it successfully, it can lead to a great deal of anxiety and confusion. We at RemotewebNEThave a specialist team that is equipped to  provide Nigeria-based  companies  with  new  office  IT  setup  solutions.  All  of  your requirements  for  IT  infrastructure-related  consultancy,  planning,  and  office  setup  are met by us.Our  crew  has  a  wealth  of  knowledge  regarding  office  IT  setup  in  various Nigerialocations. We readily adapt our designs to fit your IT infrastructure demands, adaptable to work with any timetable that you have in mind. Whether you need assistance with IT set-up for your new office in Nigeriaor need help changing your existing office space.",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "it relocation",
        desc: "Mobility  is  a  necessity  for  all  modern  enterprises.  Your  capacity  to  migrate  your corporate  infrastructure,  both  physical  and  IT,  between  sites  efficiently  and  securely gives you a competitive advantage over other businesses. RemotewebNETexpedites IT migrations,  changes,  upgrades,  and  deployment.  With  our  IT  relocation  services,  you can rest confident that every aspect of the move is meticulously planned and matched to your specific requirements. Our  team  has  over  a  decade  of  expertise  with  all  types  of  IT  relocation  services  for Nigeriaenterprises.  We  provide  clients  with  full,  end-to-end  IT  relocation  solutions, whether  it's  data  center  or  server  room  relocation,  office  migrations,  or  IT  hardware decommissioning. We handle everything from infrastructure assessment and planning to equipment acquisition and transfer of your IT assets.RemotewebNETIT  relocation  services  help  you  control  expenses,  decrease  risk, increase  flexibility,  and  reduce  downtime  in  your  organization.  Our  staff  adheres  to industry  best  practices  and  creates  detailed  documentation  of  the  entire  process  for future  use/reference.  We  also  collaborate  with  other  teams  participating  in  the relocation project to ensure a smooth transition of your business locations.You, our clients, are always our primary concern, and with our cutting-edge IT relocation services, we ensure that you have an IT environment that is smart, scalable, and trouble-free.",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "cloud migration services",
        desc: "It's a crucial and challenging process to move your company's data to a cloud provider. With more than nine years of experience as a top cloud migration service provider in Nigeria, RemotewebNEThas the knowledge to develop a cloud plan that works for you and carry out your move to the cloud with the least amount of disturbanceTo   assist   you   with   discovering,   migrating,   managing,   and   securing   your   cloud environment, our team of cloud professionals uses tried-and-true techniques and a wide range of cloud solutions. We offer full-service cloud migration solutions, collaborating with clients from planning and design to successful completion and support.While  guaranteeing  complete  client  security  and  satisfaction,  you  may  assist  your company  in  becoming  more  flexible  and  cost-effective  with RemotewebNETCloud Migration Services.",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "it consulting",
        desc: "Consistent  workflow  and  ongoing  customer  satisfaction  depend  on  high-quality  IT infrastructure.  With  the  help  of  our  IT  management  consulting  services,  you  can modernize your infrastructure withnew technologies and efficient fixes while bringing about a digital and technical transformation for the whole business. Our team strives to give  useful  recommendations  and  actionable  roadmaps  that  support  your  company's objectives and long-term strategies.We offer consulting services to handle a variety of problems that clients have over the course  of  using  their  IT  settings.  We  offer  a  wide  range  of  services,  from  consulting through system integration, upkeep, and support. We are uniquely suited to design IT strategies  for  a  variety  of  company  disciplines  thanks  to  our  nine  years  of  experience and team of industry specialists.",
        path: "",
        isActive: false,
      },
    ],
  },
  {
    header: "software solutions",
    slug: "software",
    imgUrl: softwareImg,
    bgImg: itservicesBg,
    content1:
      "At RemotewebNET, we provide innovative software solutions designed to improve our customers’ businesses. Our solutions are tailored to meet the specific needs of our clients, offering greater efficiency and productivity. We use cutting-edge technologies, such as artificial intelligence and machine learning, to create powerful solutions that optimize performance and enhance user experience. We understand the importance of security and strive to keep our customer data safe and secure.",
    content2:
      "We employ rigorous safety measures to protect our systems and guard against potential threats. We are committed to providing our customers with a reliable and secure experience when using our software solutions.",
    menu_items: [
      {
        slug: "",
        title: "web design /Development",
        desc: "RemotewebNET is a trustworthy Crisis Management Partner for businesses in Abuja, Nigeria. We develop all-in-one powerful solutions for emergencies and critical situations, allowing you to respond quickly and appropriately in such a situation.Businesses may set up fully controlled operator workstations and real-time control rooms using our advanced crisis management platform software. Our crisis experts assess your existing infrastructure risks and emergency readiness to build, manage, and support a crisis management solution that is tailored to your specific needs. We provide complete visualization tools for your control rooms, allowing you to monitor your business-critical activities from a single screen or shared screen wall. We also offer advice and training on how to recover from such catastrophes with as little disruption or loss of business as possible.RemotewebNET manages all aspects of your crisis management and business continuity activities, backed by intelligence-driven solutions. Work with us to protect your company.",
        path: "",
        isActive: true,
      },
      {
        slug: "",
        title: "Mobile App Development",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "custom software solutions",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "CMS Solutions",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "quality testing",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "it staff augmentation",
        desc: "",
        path: "",
        isActive: false,
      },
    ],
  },
  {
    header: "cyber security",
    slug: "cyber-security",
    imgUrl: cyberImg,
    bgImg: cyberBg,
    content1:
      "At RemotewebNET, we understand the importance of cyber security. We strive to provide our customers with the best possible protection against potential threats such as malicious insiders, phishing, malware, and data breaches. Our advanced security measures help protect our customers’ data and systems from malicious activity. We use automated tools to monitor and detect any potential issues before they become a problem. We have established incident response plans in the event of a cyber attack and have put together comprehensive recovery strategies to mitigate any potential damage. We provide our customers with the education and resources they need to understand the importance of cyber security. Our team of experts are dedicated to helping. ",
    content2: "",
    menu_items: [
      {
        slug: "",
        title: "next-gen  firewall",
        desc: "For companies of all sizes in Nigeria, RemotewebNETis a dependable supplier of cutting-edge firewall solutions. Both on-premises and in the cloud, our strong firewall solutions are made to be future-proof so that as your business expands, so does our security solution. In addition to delivering unmatched threat management and in-depth insights into the actions, dangers, and trends affecting your enterprise network, we offer complete visibility across your organization. We have teamed up with top-tier firewall service providers like Sophos, Cisco, and FortiGuard to  provide  our  clients  high-performance  deep  packet  inspection,  next-generation  IPS,  web protection, app control, deep learning technologies, and sandbox security to fight the newest ransomware and breaches. You can effortlessly synchronize security protocols throughout your network and extend your firewall protection to all of your end users with the help of our next-generation all-in-one firewall capabilities.",
        path: "",
        isActive: true,
      },
      {
        slug: "",
        title: "email security",
        desc: "Emails  are  crucial  for  daily  business  communication,  but  they  also  make  it  simple  for spam, spyware, phishing, ransomware, and other threats to target your company. With our    comprehensive,    completely    integrated    Email    Security    Solutions,    we    at RemotewebNETguard  your  company  and  its  employees  from  any  email  threats  and fraudulent behavior. We go above and beyond the norm to provide your business with DNS   authentication   services,   a   centralized   security   dashboard,   simple   protocol management, integrated messaging solutions to safeguard your critical data, and email protection.Our  smart  email  security  gateways,  which  are  supported  by  cutting-edge  endpointsecurity  solutions,  enable  you  to  identify  the  kind  of  threats  that  are  directed  at  your company and the employees who are most at risk of becoming victims.For almost ten years, we have led the email security sector by assisting companies in setting up secure email gateways and preventing data breaches with policy-based email encryption. Get multi-layered,  cost-effective  email  security  from RemotewebNETto  protect  yourself against dangers that are continuously changing.",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "device encryption",
        desc: "To help businesses secure and manage laptops, smartphones, and other remote devices on  their  company  network,  RemotewebNET  uses  industry-leading  device  encryption solutions. In the event of loss, theft, or damage, our solutions guard against unwanted access to your sensitive data while also enabling you to track user activity and device health throughout your whole business in real-time. When a device is lost or a user is no longer  authorized  to  use  it,  your  IT  administrators  can  remotely  lock  and  encrypt  the device using our cutting-edge services.Our  entire  device  encryption  solutions  are  simple  to  install,  work  with  a  variety  of operating systems (Windows, iOS, Linux, etc.), and are centrally administered through a cloud-based portal. They are also affordable, clever, and scalable.",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "vulnerability management",
        desc: "For  endpoints,workloads,  and  systems  to  function  together  in  a  secure  business network, a continuous, real-time vulnerability management program is essential. For our clients in Nigeria, we at RemotewebNETprovide top-notch vulnerability management tools  and  solutions using  our  knowledge  and  experience  in  the  field.  You  can  find, evaluate,  report,  manage,  and  patch  vulnerabilities  across  your  network  as  soon  as possible with the help of our vulnerability management.Our   vulnerability   management   programs   are   completely customized,   centrally controlled, and fully integrated. They give you worldwide visibility, enabling you to scan and  track  devices  across  your  internal  network,  cloud  environment,  and  external boundary.  Our  quick-to-market  vulnerability  solutions  find  threats  and  unforeseen changes in your network before they may become breaches.Working with us gives you access to vulnerability management services that grow with your business requirements without affecting the performance and productivity of your endpoints.",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "mfa & sso",
        desc: "Passwords  are  a  crucial  part  of  any  security  routine,  but  they  also  seriously  endanger your  IT  security.  We  at RemotewebNETassist  in  developing  password  solutions  to match your intricate, expanding IT infrastructure. Our Multi-Factor Authentication (MFA) and Single Sign-On (SSO) services ensure that your identity and access management setup are secure and enhance your customer satisfaction. Our  user-friendly  multi-factor  authentication  solutions  can  help  you  protect  your accounts  and  applications  from  fraud  and  credential  theft.  With  our  cutting-edge techniques, you can combine your internal and external security measures for enhanced threat  visibility,  as  well  as  proactively  monitor  and  block  any  suspiciousIP addresses from your company network, and more.To provide your business with a secure, integrated endpoint management system, our Single  Sign-On  solution  combines  market-leading  technology  with  sector  experience. They can access many accounts with a single password, which enhances the end user experience.  Additionally,  your  business  productivity  will  grow  thanks  to  our  SSO solution's  quick  integration  of  any  new  app  into  your  current  user  network  access system.",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "enterprise mobility",
        desc: "Enterprise  mobility  is  all  about  developing  better,  more  secure  solutions  that  enable users  to  connect  to  your  company's  network  and  access  pertinent  data  from  any location, at any time.Using  RemotewebNET  corporatesecurity  solutions,  you  can  manage,  identify,  and secure your mobile workforce with clever cloud-based systems. It offers simple tracking and  remote  data  management  across  all  endpoints,  giving  you  total  control  over  all authorized devices. In order to maximize corporate efficiency, our solutions also assist you in setting up all the applications and policies on a new device immediately.To  provide  these  unmatchedsolutions  for  organizations  in  Nigeria,  we  have  teamed withnumerous  industry  leaders.  Our  comprehensive,  identity-driven  security  solution guards against sophisticated attacks, stolen identities, and malicious activity both on-premises and in the cloud, protecting your secure network.With  RemotewebNET  workplacesolutions,  you  can  embrace  the  hybrid  workspace culture and equip your workers with technology that is adaptable and built-in.",
        path: "",
        isActive: false,
      },
    ],
  },
  {
    header: "cloud & servers",
    slug: "cloud-servers",
    imgUrl: cloudImg,
    bgImg: cloudBg,
    content1:
      "At RemotewebNET, we provide best-in-class cloud and server solutions tailored to meet the unique needs of our customers. We use cutting-edge technologies, such as virtualization and automation, to create robust and scalable solutions that are secure and reliable. Our solutions are designed to offer high performance and scalability in order to support our customers' growing businesses. We understand the importance of cyber security and are committed to keeping up with the latest security standards and protocols. We employ rigorous safety measures to protect our systems and customer data from malicious actors and potential threats. Our team of experts work closely with our customers to ensure their data is secure and their performance. ",
    content2: "",
    menu_items: [
      {
        slug: "",
        title: "azure",
        desc: "RemotewebNET is a trustworthy Crisis Management Partner for businesses in Abuja, Nigeria. We develop all-in-one powerful solutions for emergencies and critical situations, allowing you to respond quickly and appropriately in such a situation.Businesses may set up fully controlled operator workstations and real-time control rooms using our advanced crisis management platform software. Our crisis experts assess your existing infrastructure risks and emergency readiness to build, manage, and support a crisis management solution that is tailored to your specific needs. We provide complete visualization tools for your control rooms, allowing you to monitor your business-critical activities from a single screen or shared screen wall. We also offer advice and training on how to recover from such catastrophes with as little disruption or loss of business as possible.RemotewebNET manages all aspects of your crisis management and business continuity activities, backed by intelligence-driven solutions. Work with us to protect your company.",
        path: "",
        isActive: true,
      },
      {
        slug: "",
        title: "aws",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "hosting",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "server solutions & Storage",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "nas storage",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "synchronized Data Storage",
        desc: "",
        path: "",
        isActive: false,
      },
    ],
  },
  {
    header: "data backup & protection",
    slug: "data-backup",
    imgUrl: dataImg,
    bgImg: dataBg,

    content1:
      "At RemotewebNET, we understand the importance of protecting your data. That's why we provide comprehensive data backup and protection solutions that ensure your data is secure and available whenever you need it. Our solutions provide automated backups, advanced encryption protocols, robust disaster recovery plans, and continuous monitoring to identify any potential threats. Our data backup and protection solutions are designed to work seamlessly with your existing systems and processes, so you can rest assured that no matter what happens, your data will always be safe. We keep up-to-date with the latest technologies and trends in the industry, to give you the best protection possible from any potential cyber threats. ",
    content2: "",
    menu_items: [
      {
        slug: "",
        title: "business continuity plan",
        desc: "RemotewebNET is a trustworthy Crisis Management Partner for businesses in Abuja, Nigeria. We develop all-in-one powerful solutions for emergencies and critical situations, allowing you to respond quickly and appropriately in such a situation.Businesses may set up fully controlled operator workstations and real-time control rooms using our advanced crisis management platform software. Our crisis experts assess your existing infrastructure risks and emergency readiness to build, manage, and support a crisis management solution that is tailored to your specific needs. We provide complete visualization tools for your control rooms, allowing you to monitor your business-critical activities from a single screen or shared screen wall. We also offer advice and training on how to recover from such catastrophes with as little disruption or loss of business as possible.RemotewebNET manages all aspects of your crisis management and business continuity activities, backed by intelligence-driven solutions. Work with us to protect your company.",
        path: "",
        isActive: true,
      },
      {
        slug: "",
        title: "diaster recovery solutions",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "backup as a service",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "device management",
        desc: "",
        path: "",
        isActive: false,
      },
    ],
  },
  {
    header: "network & switching",
    slug: "network-switching",
    imgUrl: networkImg,
    bgImg: itservicesBg,
    content1:
      "At RemotewebNET, we provide a range of reliable and high-performance network solutions designed to fit the needs of any organization. Our solutions are built on cutting-edge technologies, such as high-speed switching, routing, and networking, to ensure an optimal performance. We specialize in providing secure and efficient solutions that can scale to meet our customers’ ever-changing needs. We understand the importance of security and have implemented rigorous safety measures to protect our networks and systems. Our solutions are designed to detect any potential threats, preventing malicious actors from gaining access to our customers’ networks. We strive to offer our customers a reliable, secure, and efficient experience. ",
    content2: "",
    menu_items: [
      {
        slug: "",
        title: "cabling",
        desc: "RemotewebNET is a trustworthy Crisis Management Partner for businesses in Abuja, Nigeria. We develop all-in-one powerful solutions for emergencies and critical situations, allowing you to respond quickly and appropriately in such a situation.Businesses may set up fully controlled operator workstations and real-time control rooms using our advanced crisis management platform software. Our crisis experts assess your existing infrastructure risks and emergency readiness to build, manage, and support a crisis management solution that is tailored to your specific needs. We provide complete visualization tools for your control rooms, allowing you to monitor your business-critical activities from a single screen or shared screen wall. We also offer advice and training on how to recover from such catastrophes with as little disruption or loss of business as possible.RemotewebNET manages all aspects of your crisis management and business continuity activities, backed by intelligence-driven solutions. Work with us to protect your company.",
        path: "",
        isActive: true,
      },
      {
        slug: "",
        title: "switching",
        desc: "",
        path: "",
        isActive: false,
      },
      { slug: "", title: "proxy service", desc: "", path: "", isActive: false },
    ],
  },
  {
    header: "smart home",
    slug: "smart-home",
    imgUrl: smartHomesImg,
    bgImg: itservicesBg,

    content1:
      "At RemotewebNET, we provide our customers with innovative smart home solutions that make everyday life easier. Our solutions are tailored to our customers’ specific needs, providing them with greater convenience, comfort, and security. Whether it’s controlling lights, increasing energy efficiency, or monitoring security, our solutions are designed to maximize convenience and reduce risk. Using the most up-to-date technology, we ensure that our solutions are secure and reliable. We employ rigorous safety measures to provide our customers with peace of mind when it comes to the security of their home and data. ",
    content2:
      "With our smart home’s solutions, we make sure that our customers enjoy the modern convenience and peace of mind that comes with a connected home. Our cutting-edge technologies provide our customers with powerful and secure home automation solutions that make their lives easier and more comfortable.",
    menu_items: [
      {
        slug: "",
        title: "lightening",
        desc: "RemotewebNET is a trustworthy Crisis Management Partner for businesses in Abuja, Nigeria. We develop all-in-one powerful solutions for emergencies and critical situations, allowing you to respond quickly and appropriately in such a situation.Businesses may set up fully controlled operator workstations and real-time control rooms using our advanced crisis management platform software. Our crisis experts assess your existing infrastructure risks and emergency readiness to build, manage, and support a crisis management solution that is tailored to your specific needs. We provide complete visualization tools for your control rooms, allowing you to monitor your business-critical activities from a single screen or shared screen wall. We also offer advice and training on how to recover from such catastrophes with as little disruption or loss of business as possible.RemotewebNET manages all aspects of your crisis management and business continuity activities, backed by intelligence-driven solutions. Work with us to protect your company.",
        path: "",
        isActive: true,
      },
      {
        slug: "",
        title: "surveilance",
        desc: "",
        path: "",
        isActive: false,
      },
      { slug: "", title: "censors", desc: "", path: "", isActive: false },
      {
        slug: "",
        title: "sound & video",
        desc: "",
        path: "",
        isActive: false,
      },
      { slug: "", title: "biometrics", desc: "", path: "", isActive: false },
      {
        slug: "",
        title: "access control",
        desc: "",
        path: "",
        isActive: false,
      },
    ],
  },
  {
    header: "audio-video",
    slug: "audio-video",
    imgUrl: audioImg,
    bgImg: itservicesBg,

    content1:
      "At RemotewebNET, we specialize in providing high-quality audio-video solutions for businesses. Our goal is to help our customers create effective and engaging content that resonates with their intended audiences. Our audio-video solutions combine the latest technologies, such as virtual reality, augmented reality, and streaming media, to provide immersive experiences for viewers. We understand that security is paramount when it comes to audio-video solutions. We employ robust safety measures to protect our systems and data from malicious actors. We strive to maintain the highest standards of security, ensuring our customers have a safe and secure experience when using our audio-video solutions. ",
    content2: "",
    menu_items: [
      {
        slug: "",
        title: "web design /Development",
        desc: "RemotewebNET is a trustworthy Crisis Management Partner for businesses in Abuja, Nigeria. We develop all-in-one powerful solutions for emergencies and critical situations, allowing you to respond quickly and appropriately in such a situation.Businesses may set up fully controlled operator workstations and real-time control rooms using our advanced crisis management platform software. Our crisis experts assess your existing infrastructure risks and emergency readiness to build, manage, and support a crisis management solution that is tailored to your specific needs. We provide complete visualization tools for your control rooms, allowing you to monitor your business-critical activities from a single screen or shared screen wall. We also offer advice and training on how to recover from such catastrophes with as little disruption or loss of business as possible.RemotewebNET manages all aspects of your crisis management and business continuity activities, backed by intelligence-driven solutions. Work with us to protect your company.",
        path: "",
        isActive: true,
      },
      {
        slug: "",
        title: "crisis management solutions",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "meeting room solutions",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "meeting room scheduler",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "digital signage solutions",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "video conferencing",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "public address solutions",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "smart classroom solutions",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "video wall solutions",
        desc: "",
        path: "",
        isActive: false,
      },
      {
        slug: "",
        title: "interactive display",
        desc: "",
        path: "",
        isActive: false,
      },
    ],
  },
];
const products = [
  {
    slug: "",
    title: "Laptops and Desktops",
    desc: "We provide the latest laptop and desktop technology products designed to meet the individual needs of customers. Our knowledgeable team has a great deal of experience in this domain, so rest assured that you will receive premium quality products and excellent customer service. You can trust that when you purchase from us, you are getting the very best. Don't hesitate any longer and contact us today to learn more. ",
    path: "",
    isActive: true,
  },
  {
    slug: "",
    title: "Smart Homes System",
    desc: "We provide our customers with the latest in smart home technology, designed to meet the individual needs of each customer. Our knowledgeable team has extensive experience in the industry, so you can be sure that you are getting quality products and excellent customer service. With our smart home systems, you can enjoy the convenience of automated controls, energy-efficient living and secure connectivity. Our systems are tailored to fit your lifestyle, giving you complete control over your home environment. Contact us today to find out more about our smart home systems and how they can help you. ",
    path: "",
    isActive: false,
  },
  {
    slug: "",
    title: "IP Phones ",
    desc: "We provide the latest and most advanced IP Phones and services to our customers. Our team has years of experience in the IT and telecommunications industry, so you can be sure that you are getting the best quality products and reliable services. With our IP Phones, you can enjoy crystal clear audio and video calls, secure communication and easy set-up. We understand that your business needs the best technology and service available, and we are committed to providing both. Contact us today to learn more about our IP Phones and how they can help your company. ",
    path: "",
    isActive: false,
  },
  {
    slug: "",
    title: "Firewall",
    desc: "We provide the highest quality firewall products and services to our customers. Our expert team has years of experience in the IT security industry, so you can be sure that you are getting reliable products and superior customer service. With our firewall products, you can enjoy enhanced network security, comprehensive protection against malicious activity and easy set-up. We understand that your business needs the best technology and service available, and we are committed to providing both. Contact us today to find out more about our firewall products and how they can help protect your business.",
    path: "",
    isActive: false,
  },
];
export { PatnersData, missionVisionMenu, services, products };
